import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-4 grid grid-cols-3 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_course_card = _resolveComponent("base-course-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (course) => {
      return (_openBlock(), _createBlock(_component_base_course_card, {
        key: course.id,
        course: course,
        onClick: () => _ctx.onClickCourseCard(course.id)
      }, null, 8, ["course", "onClick"]))
    }), 128))
  ]))
}